/** 한국응용과학기술학회(KSAST) 공통 브랜드 스타일 */
export type BrandTypes = typeof brand;

export const brand = {
	/** 헤더 투명 배경(메인 상단) */
	headerOverlay: 'rgba(0, 21, 52, 0.55)',
	/** 메인 배너 이미지 오버레이 — primary #12539E 기반 */
	bannerOverlay:
		'linear-gradient(105deg, rgba(0, 21, 52, 0.75) 0%, rgba(18, 83, 158, 0.88) 42%, rgba(18, 83, 158, 0.4) 100%)',
	/** 서브 페이지 배너 오버레이 */
	subBannerOverlay:
		'linear-gradient(100deg, rgba(0, 21, 52, 0.9) 0%, rgba(18, 83, 158, 0.55) 55%, rgba(18, 83, 158, 0.35) 100%)',
	/** 포커스 링 (입력 필드) */
	focusRing: 'rgba(18, 83, 158, 0.12)',
} as const;
